module.exports = __webpack_public_path__ + "img/home.463a138b.svg";